import { SearchField } from '@rematter/ui-web';

import * as state from '../../../_state/inventory.state';
import { useTranslations } from '../../../i18n/useTranslations';

import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

export const CategoriesFilters = () => {
  const t = useTranslations();

  const [searchTerm, setSearchTerm] = useDebouncedAtom(state.$searchTerm, 300);

  return (
    <SearchField
      autoFocus
      value={searchTerm ?? ''}
      onChange={setSearchTerm}
      placeholder={t.inventoryView.categoriesPanel.search.placeholder}
      aria-label={t.inventoryView.categoriesPanel.search.ariaLabel}
      className="@CategoriesFilters w-[200px] shrink-0"
    />
  );
};
